// Admin page -> permissions that open it (view on any of them)
export const ADMIN_PAGE_PERMISSIONS = {
    '/admin/dashboard': [['Dashboard', 'Admin Dashboard']],
    '/admin/users': [['Users', 'User Management']],
    '/admin/employees': [['Employees', 'Employee Management'], ['Employees', 'Partners'], ['Employees', 'Employer Applications']],
    '/admin/permissions': [['Permissions', 'Permission Management']],
    '/admin/memberships': [
        ['Memberships', 'Student Memberships'], ['Memberships', 'Coach Memberships'], ['Memberships', 'Membership Tiers'],
        ['Memberships', 'Referral Codes'], ['Memberships', 'Active Members'],
    ],
    '/admin/organizations': [['Organizations', 'Organizations']],
    '/admin/email-templates': [['Users', 'Email']],
    '/admin/surveys': [['Surveys', 'Surveys']],
    '/admin/interviewmanagement': [['AI Tools', 'Interview Management']],
    '/admin/pitchmanagement': [['AI Tools', 'Pitch Management']],
    '/admin/resume-scoring': [['AI Tools', 'Resume Scoring']],
    '/admin/lookups': [
        ['Lookups', 'Personas'], ['Lookups', 'Intents'], ['Lookups', 'Industries'],
        ['Lookups', 'Positions'], ['Lookups', 'Onboarding'], ['Lookups', 'Resources'],
    ],
    '/admin/onboarding-checklist': [['Lookups', 'Onboarding']],
    '/admin/jobmanagement': [['Jobs', 'Job Management']],
    '/admin/contact-messages': [['Support', 'Contact Messages']],
    '/admin/system-logs': [['System', 'System Logs']],
};

export function canViewAdminPage(can, path) {
    const pages = ADMIN_PAGE_PERMISSIONS[path];
    return !pages || pages.some(([category, name]) => can(category, name, 'view'));
}
